<script setup lang="ts">
import { formatPrice } from '@glow/shared/utils/format';

const props = withDefaults(
  defineProps<{
    price?: number;
    duration?: number;
  }>(),
  { price: 0, duration: 0 }
);
</script>

<template>
  <AppButton>
    <div class="duration-price-button">
      <span class="duration-price-button__secondary-text">
        {{ props.duration }} мин
      </span>
      <span><slot /></span>
      <span class="duration-price-button__secondary-text">
        {{ formatPrice(props.price) }}
      </span>
    </div>
  </AppButton>
</template>

<style scoped lang="scss">
.duration-price-button {
  display: flex;
  justify-content: space-between;
  justify-self: flex-end;

  &__secondary-text {
    color: #e5e5e5;
  }
}
</style>
